import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchUserAccount } from '@arrived/api_v2';
import { Account, PatchAccountRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { accountsPrimaryKeyFn, currentUserKeyFn, userKeyFn } from '../users';
import { accountsKeyFn } from './accounts.keys';

export function usePatchAccountMutation(options?: UseMutationOptions<Account, PatchAccountRequest>) {
  const queryClient = useQueryClient();

  return useMutation((request) => patchUserAccount(request), {
    ...options,
    onSuccess: (data, variables, context) => {
      const primaryAccount = queryClient.getQueryData<Account | undefined>(accountsPrimaryKeyFn());

      if (primaryAccount?.id === data.id) {
        queryClient.setQueryData(accountsPrimaryKeyFn(), data);
        queryClient.setQueryData(currentUserKeyFn(), data.primaryUser);

        queryClient.invalidateQueries(currentUserKeyFn());
        queryClient.invalidateQueries(accountsPrimaryKeyFn());
      }

      queryClient.setQueryData(accountsKeyFn(data.id), data);
      queryClient.setQueryData(userKeyFn(data.primaryUser.id), data.primaryUser);

      queryClient.invalidateQueries(userKeyFn(data.primaryUser.id));
      queryClient.invalidateQueries(accountsKeyFn(data.id));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
